import React, { useState, useEffect } from "react";

const API_URL = process.env.REACT_APP_API_URL + "/alarms";

const TIPURI = [
  { value: "microfon", label: "Microphone dB", unit: "dB" },
  { value: "baterie", label: "Battery %", unit: "%" },
  { value: "gsm", label: "GSM dBm", unit: "dBm" },
  { value: "senzor_proximitate", label: "Proximity sensor", unit: "cm" },
  { value: "senzor_miscare", label: "Motion sensor", unit: "value" }
];
const OPERATORI = [
  { value: ">", label: "greater than" },
  { value: "<", label: "less than" },
  { value: "=", label: "equal to" }
];
const TIP_ALERTA = [
  { value: 'completa', label: 'Full' },
  { value: 'soft', label: 'Soft' },
  { value: 'intarziata', label: 'Delayed' },
  { value: 'ignorare', label: 'Ignore' }
];

const TIPURI_LABEL = {
  microfon: "Microphone dB",
  baterie: "Battery %",
  gsm: "GSM dBm",
  senzor_proximitate: "Proximity sensor",
  senzor_miscare: "Motion sensor"
};
const TIPURI_UNIT = {
  microfon: "dB",
  baterie: "%",
  gsm: "dBm",
  senzor_proximitate: "cm",
  senzor_miscare: ""
};
const OP_LABEL = {
  ">": "greater than",
  "<": "less than",
  "=": "equal to"
};

function formatConditie(cond) {
  if (!cond || typeof cond !== 'object') return '';
  return `${TIPURI_LABEL[cond.tip] || cond.tip} ${OP_LABEL[cond.operator] || cond.operator} ${cond.valoare}${TIPURI_UNIT[cond.tip] ? ' ' + TIPURI_UNIT[cond.tip] : ''}`;
}

function formatDeclansatori(json) {
  try {
    const arr = typeof json === 'string' ? JSON.parse(json) : json;
    if (Array.isArray(arr)) {
      return arr.map(formatConditie).join(', ');
    }
    return '';
  } catch {
    return '';
  }
}

export default function AlarmSettings() {
  const [alarms, setAlarms] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ scenariu: "", conditii: [], timp: { value: '', unit: 'seconds' }, tip: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Fetch alarme la montare
  useEffect(() => {
    fetchAlarms();
  }, []);

  const fetchAlarms = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await fetch(API_URL);
      if (!res.ok) throw new Error("Error loading alarms");
      const data = await res.json();
      setAlarms(data);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  // Adaugă o condiție nouă
  const adaugaConditie = () => {
    setForm({ ...form, conditii: [...form.conditii, { tip: "microfon", operator: ">", valoare: "" }] });
  };
  // Modifică o condiție
  const modificaConditie = (idx, field, value) => {
    const newConditii = [...form.conditii];
    newConditii[idx][field] = value;
    setForm({ ...form, conditii: newConditii });
  };
  // Șterge o condiție
  const stergeConditie = (idx) => {
    setForm({ ...form, conditii: form.conditii.filter((_, i) => i !== idx) });
  };

  // Adaugă alarmă nouă
  const handleAdd = async () => {
    setLoading(true);
    setError("");
    try {
      let timpSec = parseInt(form.timp.value || 0, 10);
      if (form.timp.unit === 'minutes') timpSec = timpSec * 60;
      const payload = {
        scenariu: form.scenariu,
        declansatori: JSON.stringify(form.conditii),
        timp: timpSec,
        tip: form.tip
      };
      const res = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });
      if (!res.ok) throw new Error("Error saving alarm");
      setForm({ scenariu: "", conditii: [], timp: { value: '', unit: 'seconds' }, tip: "" });
      setShowForm(false);
      fetchAlarms();
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  // Șterge alarmă
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this alarm?")) return;
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${API_URL}/${id}`, { method: "DELETE" });
      if (!res.ok) throw new Error("Error deleting alarm");
      fetchAlarms();
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: "100vh",
      minWidth: "100vw",
      background: "#f8f8f8",
      display: "flex",
      flexDirection: "column",
      alignItems: "stretch",
      justifyContent: "flex-start",
      paddingTop: 40
    }}>
      <button
        style={{
          marginBottom: 20,
          padding: "12px 28px",
          background: "#27ae60",
          color: "white",
          border: "none",
          borderRadius: 8,
          fontWeight: "bold",
          fontSize: 18,
          cursor: "pointer",
          alignSelf: 'center',
          boxShadow: '0 2px 8px #0001',
          transition: 'background 0.2s, box-shadow 0.2s',
        }}
        onMouseOver={e => e.currentTarget.style.background = '#219150'}
        onMouseOut={e => e.currentTarget.style.background = '#27ae60'}
        onClick={() => setShowForm(true)}
      >
        Create new alarm/scenario
      </button>
      {error && <div style={{ color: 'red', alignSelf: 'center', marginBottom: 10 }}>{error}</div>}
      {loading && <div style={{ alignSelf: 'center', marginBottom: 10 }}>Loading...</div>}
      <div style={{
        width: '100vw',
        overflowX: 'auto',
        boxShadow: '0 2px 12px #0001',
        borderRadius: 18,
        background: '#fff',
        marginBottom: 30,
        padding: 8
      }}>
        <table style={{
          width: "100%",
          borderCollapse: "separate",
          borderSpacing: 0,
          fontSize: 18,
          borderRadius: 18,
          overflow: 'hidden'
        }}>
          <thead>
            <tr style={{
              background: "#27ae60"
            }}>
              <th style={{
                padding: 18,
                border: "none",
                fontWeight: 700,
                color: "#fff",
                fontSize: 20,
                textAlign: "center",
                verticalAlign: "middle"
              }}>Scenario</th>
              <th style={{
                padding: 18,
                border: "none",
                fontWeight: 700,
                color: "#fff",
                fontSize: 20,
                textAlign: "center",
                verticalAlign: "middle"
              }}>Triggers</th>
              <th style={{
                padding: 18,
                border: "none",
                fontWeight: 700,
                color: "#fff",
                fontSize: 20,
                textAlign: "center",
                verticalAlign: "middle"
              }}>Confirmation time</th>
              <th style={{
                padding: 18,
                border: "none",
                fontWeight: 700,
                color: "#fff",
                fontSize: 20,
                textAlign: "center",
                verticalAlign: "middle"
              }}>Alert type</th>
              <th style={{
                padding: 18,
                border: "none",
                fontWeight: 700,
                color: "#fff",
                fontSize: 20,
                textAlign: "center",
                verticalAlign: "middle"
              }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {alarms.map((a, idx) => (
              <tr key={a.id || idx}
                style={{
                  background: idx % 2 === 0 ? '#fff' : '#f4f8f4',
                  transition: 'background 0.2s'
                }}
                onMouseOver={e => e.currentTarget.style.background = '#eafbe7'}
                onMouseOut={e => e.currentTarget.style.background = idx % 2 === 0 ? '#fff' : '#f4f8f4'}
              >
                <td style={{ padding: 18, border: "none", borderBottom: "1px solid #e0e0e0", textAlign: 'center', verticalAlign: 'middle' }}>{a.scenariu}</td>
                <td style={{ padding: 18, border: "none", borderBottom: "1px solid #e0e0e0", textAlign: 'center', verticalAlign: 'middle' }}>{formatDeclansatori(a.declansatori)}</td>
                <td style={{ padding: 18, border: "none", borderBottom: "1px solid #e0e0e0", textAlign: 'center', verticalAlign: 'middle' }}>{a.timp}</td>
                <td style={{ padding: 18, border: "none", borderBottom: "1px solid #e0e0e0", textAlign: 'center', verticalAlign: 'middle' }}>{a.tip}</td>
                <td style={{ padding: 18, border: "none", borderBottom: "1px solid #e0e0e0", textAlign: 'center', verticalAlign: 'middle' }}>
                  <button onClick={() => handleDelete(a.id)} style={{ background: '#e74c3c', color: '#fff', border: 'none', borderRadius: 6, padding: '6px 18px', fontWeight: 'bold', cursor: 'pointer' }}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showForm && (
        <div style={{
          position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
          background: "rgba(0,0,0,0.3)", display: "flex", alignItems: "center", justifyContent: "center",
          zIndex: 1000
        }}>
          <div style={{
            background: "#fff",
            padding: 50,
            borderRadius: 16,
            minWidth: 600,
            maxWidth: 900,
            width: '60vw',
            boxShadow: '0 8px 32px #0003',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            border: '2px solid #27ae60'
          }}>
            <h3 style={{ fontSize: 28, marginBottom: 30, color: '#27ae60' }}>Add alarm/scenario</h3>
            <input placeholder="Scenario" value={form.scenariu} onChange={e => setForm({ ...form, scenariu: e.target.value })} style={{ width: "100%", marginBottom: 18, fontSize: 20, padding: 12, borderRadius: 8, border: '1px solid #ccc', outline: 'none', transition: 'border 0.2s' }} onFocus={e => e.target.style.border = '2px solid #27ae60'} onBlur={e => e.target.style.border = '1px solid #ccc'} />
            {/* Condiții declanșatori */}
            <div style={{ width: '100%', marginBottom: 18 }}>
              <div style={{ fontWeight: 600, marginBottom: 8 }}>Triggers:</div>
              {form.conditii.map((c, idx) => {
                const tipObj = TIPURI.find(t => t.value === c.tip) || {};
                return (
                  <div key={idx} style={{ display: 'flex', gap: 8, marginBottom: 8, alignItems: 'center' }}>
                    <select value={c.tip} onChange={e => modificaConditie(idx, 'tip', e.target.value)} style={{ fontSize: 18, padding: 6, borderRadius: 6 }}>
                      {TIPURI.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
                    </select>
                    <select value={c.operator} onChange={e => modificaConditie(idx, 'operator', e.target.value)} style={{ fontSize: 18, padding: 6, borderRadius: 6 }}>
                      {OPERATORI.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                    </select>
                    <input type="number" value={c.valoare} onChange={e => modificaConditie(idx, 'valoare', e.target.value)}
                      style={{ width: 80, fontSize: 18, padding: 6, borderRadius: 6 }}
                      placeholder={tipObj.unit || 'value'}
                    />
                    <span style={{ minWidth: 32, color: '#888', fontWeight: 600 }}>{tipObj.unit || ''}</span>
                    <button type="button" onClick={() => stergeConditie(idx)} style={{ background: '#e74c3c', color: '#fff', border: 'none', borderRadius: 6, padding: '6px 12px', fontWeight: 'bold', cursor: 'pointer' }}>Delete</button>
                  </div>
                );
              })}
              <button type="button" onClick={adaugaConditie} style={{ background: '#27ae60', color: '#fff', border: 'none', borderRadius: 6, padding: '6px 18px', fontWeight: 'bold', cursor: 'pointer', marginTop: 4 }}>Add condition</button>
            </div>
            <input type="number" min="0" placeholder="Confirmation time" value={form.timp.value} onChange={e => setForm({ ...form, timp: { ...form.timp, value: e.target.value } })} style={{ width: "60%", marginBottom: 18, fontSize: 20, padding: 12, borderRadius: 8, border: '1px solid #ccc', outline: 'none', transition: 'border 0.2s', display: 'inline-block' }} />
            <select value={form.timp.unit} onChange={e => setForm({ ...form, timp: { ...form.timp, unit: e.target.value } })} style={{ width: "38%", marginLeft: '2%', marginBottom: 18, fontSize: 20, padding: 12, borderRadius: 8, border: '1px solid #ccc', outline: 'none', transition: 'border 0.2s', display: 'inline-block' }}>
              <option value="seconds">seconds</option>
              <option value="minutes">minutes</option>
            </select>
            <select value={form.tip} onChange={e => setForm({ ...form, tip: e.target.value })}
              style={{ width: "100%", marginBottom: 18, fontSize: 20, padding: 12, borderRadius: 8, border: '1px solid #ccc', outline: 'none', transition: 'border 0.2s' }}>
              <option value="">Choose alert type</option>
              {TIP_ALERTA.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
            </select>
            <div style={{ marginTop: 20, display: 'flex', gap: 20 }}>
              <button onClick={handleAdd} style={{ background: "#27ae60", color: "#fff", border: "none", borderRadius: 8, padding: "12px 32px", fontSize: 18, fontWeight: 'bold', boxShadow: '0 2px 8px #0001', transition: 'background 0.2s' }} onMouseOver={e => e.currentTarget.style.background = '#219150'} onMouseOut={e => e.currentTarget.style.background = '#27ae60'}>Save</button>
              <button onClick={() => setShowForm(false)} style={{ background: "#e74c3c", color: "#fff", border: "none", borderRadius: 8, padding: "12px 32px", fontSize: 18, fontWeight: 'bold', boxShadow: '0 2px 8px #0001', transition: 'background 0.2s' }} onMouseOver={e => e.currentTarget.style.background = '#b91d1d'} onMouseOut={e => e.currentTarget.style.background = '#e74c3c'}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
} 